<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <h1 class="title is-5">{{ $t('routes.editSurvey') }}</h1>
      <div class="form-container">
        <SurveyForm @save="save" :survey-data="surveyData"></SurveyForm>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import {mapState} from 'vuex'
  import DashboardLayout from '@/components/DashboardLayout'
  import SurveyForm from '@/components/SurveyForm'

  export default {
    components: {
      DashboardLayout,
      SurveyForm
    },
    methods: {
      save(form) {
        this.$store.dispatch('Survey/update', form).then(() => {
          this.$router.push({ name: 'surveys' })
        })
      }
    },
    mounted() {
      this.$store.dispatch('Survey/getForm', this.$route.params.surveyId)
    },
    computed: {
      ...mapState('Survey', ['survey']),
      surveyData() {
        return {
          ...this.survey,
          ends_at: new Date(this.survey.ends_at)
        }
      },
      breadcrumbs() {
        return [
          {name: 'surveys', path: 'surveys'},
          {name: 'editSurvey'}
        ]
      }
    }
  }
</script>